import { useCallback, useEffect, useMemo, useState } from 'react';
import { defaultGetPasswordlessLoginSettings } from '../Util.js';
import useObjectKeysMemoize from './useObjectKeysMemoize.js';
import { EMPTY_OBJ, RequestLoginCodeDefaultProps } from '../Constants.js';
export default function useRequestLoginCode(opts) {
  const {
    classNames = EMPTY_OBJ,
    variants: pVariants,
    options: pOptions,
    components: pComponents,
    onRequestLoginCode,
    onBackToLogin,
    onAfterRequestLoginCode,
    onRequestLoginCodeError,
    getPasswordlessLoginSettings = defaultGetPasswordlessLoginSettings,
    ...restProps
  } = opts;
  const v = useObjectKeysMemoize(pVariants);
  const variants = useMemo(() => {
    return {
      ...RequestLoginCodeDefaultProps.variants,
      ...v
    };
  }, [v]);
  const o = useObjectKeysMemoize(pOptions);
  const options = useMemo(() => {
    return {
      ...RequestLoginCodeDefaultProps.options,
      ...o
    };
  }, [o]);
  const c = useObjectKeysMemoize(pComponents);
  const components = useMemo(() => {
    return {
      ...RequestLoginCodeDefaultProps.components,
      ...c
    };
  }, [c]);
  const rest = useObjectKeysMemoize(restProps);
  const [loading, setLoading] = useState(false);
  const [passwordlessLoginSettings, setPasswordlessLoginSettings] = useState();
  const [error, setError] = useState();
  const [submitted, setSubmitted] = useState();

  // Load login with code settings for project
  useEffect(() => {
    const getSettings = async () => {
      const projectId = window.Molten?.getConfig('api/projectId') || process.env.PROJECT_ID;
      try {
        const settings = await getPasswordlessLoginSettings(projectId);
        setPasswordlessLoginSettings(settings);
      } catch (err) {
        setError(err);
        setPasswordlessLoginSettings(null);
      }
    };
    getSettings();
  }, []);
  const onSubmit = useCallback(({
    email,
    data
  }) => {
    setLoading(true);
    setError(null);
    const prom = onRequestLoginCode?.(email.trim(), data);
    if (prom?.then) {
      prom.then((...args) => {
        setSubmitted(true);
        return onAfterRequestLoginCode?.(...args);
      }).catch(err => {
        setError(err);
        onRequestLoginCodeError?.(err);
      }).finally(() => {
        setLoading(false);
      });
    } else {
      setSubmitted(true);
      setLoading(false);
    }
  }, [onRequestLoginCode, onAfterRequestLoginCode, onRequestLoginCodeError]);
  return useMemo(() => {
    return {
      classNames,
      variants,
      components,
      options,
      ...rest,
      onBackToLogin,
      state: {
        error,
        loading,
        onSubmit,
        passwordlessLoginSettings,
        submitted
      }
    };
  }, [classNames, components, error, loading, onBackToLogin, onSubmit, options, passwordlessLoginSettings, rest, submitted, variants]);
}